


<template>
     <!-- box Preview -->
      <div class="py-1 ">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header pb-0">
              
                <div class="align-items-center">
                  <p class="mb-0 text-lg text-center text-black">
                    Verify VAT Refund Application for Tourists </p>
                  <p class="mb-0 text-md text-center text-black">
                  Receipt No. :{{ receiptsCode }} 
                  </p>
                  <p class="mb-0 text-md text-center text-black">
                  Store No. : {{ storeNumber }} 
                  </p>
                </div>
              </div>

      
              <div class="card-body mt-1">
                <p class="mb-0 text-md text-left text-black">
               VAT Refund Application for Tourists Information : {{ taxID }} 
                </p>
                <hr class="horizontal dark" />
              
              

               

                  <div class="row mt-3">
                    <div class="col-md-12">
                      <p class="mb-0">  Name  </p>
                      <p class="text-normal text-black"> {{ fullName }}  </p>
                    </div>
                  </div>

                     <div class="row mt-3">
                    <div class="col-md-12">
                      <p class="mb-0">  Surname </p>
                      <p class="text-normal text-black"> {{ lastName }}  </p>
                    </div>
                  </div>
                  

                  <div class="row mt-3" >
                    <div class="col-md-12">
                      <p class="mb-0">  Country </p>
                      <p class="text-normal text-black"> {{country.name_en}} </p>
                    </div>
                  </div>

                

                   <div class="row mt-3" hidden>
                    <div class="col-md-12">
                      <p class="mb-0">  Nationality </p>
                      <p class="text-normal text-black"> {{ nationalityName.national_name }}  </p>
                    </div>
                  </div>


                  <div class="row mt-3">
                    <div class="col-md-12">
                      <p class="mb-0">  Passport No. </p>
                      <p class="text-normal text-black"> {{ passportNo }} </p>
                    </div>
                  </div>

                     <div class="row mt-3" hidden>
                    <div class="col-md-12">
                      <p class="mb-0">  Arrival Date </p>
                      <p class="text-normal text-black"> {{ arrivalDate }}  </p>
                    </div>
                  </div>
             
                     <div class="row mt-3" hidden>
                    <div class="col-md-12">
                      <p class="mb-0">  Departure Date </p>
                      <p class="text-normal text-black"> {{ departureDate }}  </p>
                    </div>
                  </div>

                  <div class="row mt-3" hidden>
                    <div class="col-md-12">
                      <p class="mb-0">  Permanent/Mailing Address 1 </p>
                      <p class="text-normal text-black"> {{ customerAddress }}  </p>
                    </div>
                  </div>


                  <div class="row mt-3" hidden>
                    <div class="col-md-12">
                      <p class="mb-0">  Permanent/Mailing Address 2 </p>
                      <p class="text-normal text-black"> {{ customerAddress_2 }}  </p>
                    </div>
                  </div>

                   <div class="row mt-3" hidden>
                    <div class="col-md-12">
                      <p class="mb-0">  Post Code </p>
                      <p class="text-normal text-black"> {{ postCode }} </p>
                    </div>
                  </div>

                     <div class="row mt-3" hidden>
                    <div class="col-md-12">
                      <p class="mb-0">  City </p>
                      <p class="text-normal text-black"> {{ cityName }} </p>
                    </div>
                  </div>
              

                     <div class="row mt-3">
                    <div class="col-md-12">
                      <p class="mb-0"> Email  </p>
                      <p class="text-normal text-black"> {{ email }} </p>
                    </div>
                  </div>



                  <div class="row mt-3" hidden>
                    <div class="col-md-12">
                      <p class="mb-0">  Mobile Phone Number </p>
                      <p class="text-normal text-black"> {{ phoneNumber }}  </p>
                    </div>
                  </div>   
                <!-- <hr class="horizontal dark" /> -->
            
              </div>
            </div>
          </div>
          
        </div>
     </div>
     <!-- END box Preview -->

      <!-- ListItem -->

      <div class="py-1 mt-2">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-1">
                <p class="mb-0 text-md text-left text-black">
               Purchase Details
                </p>
                <hr class="end-box" />
              
              

                  <div class="row mt-3">
                    <div class="col-md-12">
                   <table style="width: 100%;">
                      <thead>
                        <tr>
                          <td class="text-left" style="color:black;font-size:14px;">Item</td>
                          <td class="text-center"  style="color:black;font-size:14px;">Quantity</td>
                          <td class="text-center"  style="color:black;font-size:14px;"> Price</td>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="purchaseDetails.length > 0">
                          <tr v-for="(detail, index) in purchaseDetails" :key="detail.item + index">
                            <td class="text-left"  style="color:black;font-size:14px;">{{ detail.item }}</td>
                            <td class="text-center" style="color:black;font-size:14px;">{{ detail.qty }}</td>
                            <td class="text-center" style="color:black;font-size:14px;">{{ detail.amount ? detail.amount.toLocaleString() : '0' }}</td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="3" class="text-center text-muted">
                            {{ currentMessages.NoPurchaseDetailsFound || ' - ' }}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2" class="text-right"><strong style="color:black;">Total</strong></td>
                         <td class="text-left"><strong style="color:black;">{{ totalAmount.toLocaleString() }}</strong></td>

                        </tr>
                      </tbody>
                    </table>

                    
                    </div>
                  </div>



                
              </div>
            </div>
          </div>
          
        </div>
      </div>

         <!-- END ListItem-->


      <div class="row mb-5 mt-2 px-4">
        <span class="text-danger  mb-2"> The company reserves the right not to make retroactive correction in any case</span>
          <div class="col-md-6">
              <GlobalButtonPrv @click="handleClickEdit">
                Edit  <i class="fa fa-pencil" aria-hidden="true"  style="font-size: 18px; margin-left:5px;"></i>

              </GlobalButtonPrv>
          </div>
          <div class="col-md-6">
            <GlobalButtonNext  :disabled="isSubmitting" @click="handleClickNextPage">
               Submit  <i class="fa fa-paper-plane" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
            </GlobalButtonNext>
        </div>
      </div>
      <br>
    
    <PopupModal
      :visible="isModalVisible"
      :title="modalTitle"
      :message="modalMessage"
      :subMessage="modalSubMessage"
      :closeText="'Close'"
      @close="isModalVisible = false"
    />
  <!-- <button class="btn btn-warning" @click="showModalCase(1)">Test Case 1</button>
  <button class="btn btn-warning" @click="showModalCase(2)">Test Case 2</button> -->

</template>







<script setup>

import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
import GlobalButtonPrv from "@/components/global/GlobalButtonGrey.vue";
import PopupModal from "@/components/global/ModalAlert.vue"; 
//import { useRouter } from 'vue-router' 
import { useReceiptStoreEvrt } from '@/store/useReceiptStoreEvrt';
import { ref, computed, onMounted , nextTick } from "vue";
import { CreateEvrtInvoiceRequest , fetchGetOrderReceiptItem} from '@/service-api/request-api-evrt';

const receiptStore = useReceiptStoreEvrt();

const fullName = receiptStore.full_name;
const lastName = receiptStore.last_name;
const taxID = receiptStore.tax_id;
const receiptsCode = receiptStore.receiptsCode;
const storeNumber = receiptStore.storeNumber;
const postCode = receiptStore.post_code;
const customerAddress = receiptStore.customer_address;
const customerAddress_2 = receiptStore.customer_address_2;
const phoneNumber = receiptStore.phone_number;
const arrivalDate = receiptStore.arrivalDate;
const departureDate = receiptStore.departureDate;
const country = receiptStore.country;


const nationalityName = receiptStore.nationality_name;
const passportNo = receiptStore.passport_no;
const cityName = receiptStore.city_name;
const email = receiptStore.email;

    //  email_important: email_important.value,
import messages from '@/locales/messages';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);

const emit = defineEmits(['next', 'prev', 'sendotp', 'invoice', 'preview', 'submission']);
const handleClickEdit = () => {
  emit('invoice'); 
};

const isSubmitting = ref(false);

const modalCases = {
  1: {
    message: "Please check your First and Last Name <br> Use English letters (A–Z) only.",
  },
  2: {
    message: "Please check your First and Last Name <br> Use English letters (A–Z) only.",
  },
  3: {
    message: "Invalid Passport Number <br> Please enter a valid passport number.",
  },
   4: {
    message: "Please check your Email Address <br> Please enter a valid email format.",
  },
  0: {
    message: "An error occurred. Please try again.",
  }
};


const modalTitle = ref('');
const modalMessage = ref('');
const modalSubMessage = ref('');
const isModalVisible = ref(false);

const showModalCase = (caseNumber) => {
  const caseData = modalCases[caseNumber] || modalCases[0];
  modalTitle.value = "Error";
  modalMessage.value = caseData.message;
  modalSubMessage.value = caseData.subMessage || '';
  isModalVisible.value = false; // reset
  nextTick(() => {
    isModalVisible.value = true; // trigger modal
  });
};


const handleClickNextPage = async () => {

  if (isSubmitting.value) return; // ป้องกันกดซ้ำ
  isSubmitting.value = true;
  try {
   const payload = {
      receipts_code: receiptStore.receiptsCode,
      entity_type: "NIDN",
      full_name: normalizeToEnglish(receiptStore.full_name), 
      last_name: normalizeToEnglish(receiptStore.last_name),
      passport_no: receiptStore.passport_no, // 
      nationality_name: nationalityName.national_name || '', // 
      tax_id: receiptStore.tax_id,
      store_number: receiptStore.storeNumber,
     
      post_code: receiptStore.post_code, //
      customer_address: receiptStore.customer_address,//
      customer_address_2: receiptStore.customer_address_2,//
     
      total_amount:  0,       
      total_vat: 0,             
      total_discount: 0,  
      is_interface: true,
      arrivalDate: receiptStore.arrivalDate, //
      departureDate: receiptStore.departureDate, //
      city_name: receiptStore.city_name, //
      country: receiptStore.country?.name_en || '',//
      country_code_iso3: receiptStore.country?.iso3 || '',//
      phone_number: receiptStore.phone_number,//
      email: receiptStore.email, // 
      create_by: "user",
      update_by: "user"

    };


    const response = await CreateEvrtInvoiceRequest(payload);
if (response && ['error', 'validation_error', 'fail'].includes(response.status)) {
  // console.log('Backend returned error:', response);
  // console.log('Response code:', response.code, 'Response message:', response.message);
  switch(response.code) {
    case 'E001': showModalCase(1); break;
    case 'E002': showModalCase(2); break;
    case 'E003': showModalCase(3); break;
    case 'E004': showModalCase(4); break;
    default: {
      if (response.message) modalCases[0].message = response.message;
      showModalCase(0);
    }
  }
  isSubmitting.value = false;
  return;
}

    emit('submission'); 
    console.log('Success:', response);
  } catch (err) {

      //  console.log('Caught raw error:', err);

      let res = {};

      if (err.response?.data) {
      res = err.response.data;
      }
      else if (typeof err === 'string') {
      try {
        // ลบ null ต่อท้ายก่อน parse
        const cleaned = err.replace(/null$/, '');
        res = JSON.parse(cleaned);
      } catch (parseErr) {
        console.error('Failed to parse string error:', parseErr);
        res = { code: '0', message: 'Unknown error occurred' };
      }
      }
      // 3. fallback
      else {
      res = { code: err?.code || '0', message: err?.message || 'Unknown error occurred' };
      }

      const code = res.code || '0';
      const message = res.message || '';

      let caseNumber = 0;
      if (code === 'E001') caseNumber = 1;
      else if (code === 'E002') caseNumber = 2;
      else if (code === 'E003') caseNumber = 3;
      else if (code === 'E004') caseNumber = 4;

      console.log(`Processed error. Showing modal case: ${caseNumber}, message: ${message}`);

      showModalCase(caseNumber);
      isSubmitting.value = false;

  }
};

const purchaseDetails = ref([]);

const normalizeToEnglish = (value) => {
  if (!value) return '';
  return value
    .normalize('NFD')                 // แยกตัวอักษร + diacritics
    .replace(/[\u0300-\u036f]/g, '') // ลบ diacritics
    .replace(/[^A-Za-z .'-]/g, '');  // เหลือเฉพาะ A–Z a–z space . ' -
};


onMounted(async () => {
  try {
    const res = await fetchGetOrderReceiptItem({
      receipt_code: receiptStore.receiptsCode,
      store_code: receiptStore.storeNumber,
    });

    if (res && res.fail_case === 0 && Array.isArray(res.items)) {
      purchaseDetails.value = res.items.map((item) => ({
      item: item.product_name,
      qty: item.qty,
      amount: item.net_sales || 0,
    }));
    } else {
      console.warn('No items or fail_case != 0', res);
    }
  } catch (err) {
    console.error('Failed to fetch receipt items:', err);
  }
});

const totalAmount = computed(() => {
  const total = purchaseDetails.value.reduce((sum, detail) => {
    const amountNumber = Number(detail.amount) || 0;
    return sum + amountNumber;
  }, 0);
  //console.log('totalAmount computed:', total);
  return total;
});





</script>
<style scoped>
.radio-focused {
  border-color: orange !important;
  border-width: 2px;
  background-color: #ffffff;
}

.box-boder{
  border-radius: 10px!important;
}
.custom-radio-label {
  
    margin-bottom: 0;
}

 .input-border{
     
      border-radius: 10px!important;
    }
    
</style>
